import React, { useState, useEffect } from "react";
import Button from "web/components/Button";
import DatePicker from "web/components/DatePicker";
import * as moment from "moment";
import MultiSelect from "web/components/MultiSelect";
import styled from "styled-components";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";

export default ({ isOpen, toggle, callBackFun, currentTabValue, fieldValues }) => {

  let statusArr = []
  if (currentTabValue === 0) {
    statusArr = [
      { label: "Pending", value: "PENDING" },
    ]
  } else if (currentTabValue === 1) {
    statusArr = [

      { label: "Assigned", value: "ASSIGNED" },
      { label: "Rescheduled", value: "RESCHEDULED" },
    ]
  } else if (currentTabValue === 2) {
    statusArr = [
      { label: "Picked up", value: "PICKEDUP" },
      { label: "Hold", value: "HOLD" },
    ]
  } else {
    statusArr = [
      { label: "Assigned", value: "ASSIGNED" },
      { label: "Rescheduled", value: "RESCHEDULED" },
      { label: "Picked up", value: "PICKEDUP" },
      { label: "Hold", value: "HOLD" },
      { label: "Completed", value: "COMPLETE" },
      { label: "Canceled", value: "CANCELLED" },
      { label: "Claimed", value: "CLAIM" },
    ]
  }

  const getAuthInitialValues = () => {
    return {
      orderStatus: fieldValues.orderStatus,
      fromDateOrderFilter: fieldValues.fromDateOrderFilter,
      toDateOrderFilter: fieldValues.toDateOrderFilter,
    };
  };

  const VALIDATION_SCHEMA = () => {
    return Yup.object().shape({
      fromDateOrderFilter: Yup.date()
        .typeError('Invalid date')
        .nullable()
        .required('Invalid date')
        .test('from-date-validation', 'Invalid date', function (value) {
          const { toDateOrderFilter } = this.parent;
          if (value && toDateOrderFilter && value > toDateOrderFilter) {
            return this.createError({ message: 'Invalid date' });
          }
          return true;
        }),
      toDateOrderFilter: Yup.date()
        .typeError('Invalid date')
        .nullable()
        .required('Invalid date')
        .test('to-date-validation', 'Invalid date', function (value) {
          const { fromDateOrderFilter } = this.parent;
          if (value && fromDateOrderFilter && value < fromDateOrderFilter) {
            return this.createError({ message: 'Invalid date' });
          }
          return true;
        }),
    });
  };

  return (
    <div className="alert-modal">
      <Formik
        enableReinitialize
        initialValues={getAuthInitialValues()}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const { setFieldValue, isValid, errors } = props;
          return (
            <>
              <Form>
                <Modal isOpen={isOpen} centered={true} size="md">
                  <ModalHeader toggle={() => toggle()}>
                    <h6>Filter by </h6>
                  </ModalHeader>
                  <ModalBody>
                    <DropDownWrapper>
                      <div className="dropDown">
                        <label>Pickup Order Status</label>
                        <div style={{ border: '1px solid #87cdf1', borderRadius: '3px' }}>
                          <MultiSelect
                            name="orderStatus"
                            data={statusArr}
                            disabled={!(currentTabValue === 6 || currentTabValue === 2 || currentTabValue === 1)}
                            multiSelectVal={props.values.orderStatus}
                            defaultValueArr={props.values.orderStatus}
                            placeholder='All'
                            isSearchable={false}
                            onChangeHandler={(data) => {
                              setFieldValue('orderStatus', data)
                            }}
                          />
                        </div>
                      </div>
                    </DropDownWrapper>
                    <SelectWrapper>
                      <label>Requested Date</label>
                      <div>
                        <div>
                          <DatePicker
                            name="fromDateOrderFilter"
                            value={moment(props.values?.fromDateOrderFilter).format('MM/DD/YYYY')}
                            maxDOBirth={moment(props.values.toDateOrderFilter).format('MM/DD/YYYY')}
                            callBackFun={(date) => setFieldValue("fromDateOrderFilter", date)}
                          />
                          {errors?.fromDateOrderFilter && <span className="error-message">{errors?.fromDateOrderFilter}</span>}
                        </div>
                        <p style={{ 'margin-top': '5px' }}>To</p>
                        <div>
                          <DatePicker
                            name="toDateOrderFilter"
                            value={moment(props.values.toDateOrderFilter).format('MM/DD/YYYY')}
                            minDOBirth={moment(props.values?.fromDateOrderFilter).format('MM/DD/YYYY')}
                            callBackFun={(date) => setFieldValue("toDateOrderFilter", date)}
                          />
                          {errors?.toDateOrderFilter && <span className="error-message">{errors?.toDateOrderFilter}</span>}
                        </div>
                      </div>
                    </SelectWrapper>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="app-green-button"
                      disabled={!isValid}
                      handleClick={() => {
                        callBackFun(props.values);
                        toggle();
                      }}
                    >
                      Apply Filter
                    </Button>
                  </ModalFooter>
                </Modal>
              </Form>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .dropDown {
    div {
      p {
        margin: 12px;
      }
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .error-message{
    color: #ff1414 !important;
    font-size: 11px !important;
    margin: 0 !important;
    font-family: 'latoregular' !important;
  }
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  .dropDown {
    width: 200px;
  }
  select,
  // input {
  //   padding: 5px;
  //   border: solid 1px transparent !important;
  //   margin: 2px 0;
  //   font-size: 16px;
  //   padding: 10px 13px 10px 13px;
  //   border-radius: 5px;
  //   background-color: #e8e2e2;
  //   -webkit-appearance: none;
  //   -moz-appearance: none;
  //   appearance: none;
  //   ::-webkit-input-placeholder {
  //     /* Edge */
  //     color: #656565;
  //   }

  //   :-ms-input-placeholder {
  //     /* Internet Explorer 10-11 */
  //     color: #656565;
  //   }

  //   ::placeholder {
  //     color: #656565;
  //   }
  // }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;
